import { ThemeConfig } from "antd";

export const baseTokens = {
  fontFamily:
    "Geist, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  borderRadius: 8,
  fontSize: 14,
  colorSuccess: "#10b981",
  colorWarning: "#f59e0b",
  colorError: "#ef4444",
  colorInfo: "#3b82f6",
};

export const themes: Record<string, ThemeConfig> = {
  blue: {
    token: {
      ...baseTokens,
      colorPrimary: "#1677ff",
      colorTextBase: "#1e293b",
      colorBgLayout: "#f1f5f9",
      colorBgContainer: "#ffffff",
      colorBorder: "#e2e8f0",
      colorTextSecondary: "#64748b",
      colorFillAlter: "#f8fafc",
      colorFillContent: "#f1f5f9",
      boxShadow:
        "0 1px 3px 0 rgba(0,0,0,0.06), 0 1px 2px -1px rgba(0,0,0,0.04)",
      boxShadowSecondary:
        "0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.04)",
    },
    components: {
      Button: {
        controlHeight: 38,
        fontWeight: 500,
        borderRadius: 8,
      },
      Layout: {
        headerBg: "#0f172a",
        siderBg: "#0f172a",
      },
      Menu: {
        darkItemBg: "#0f172a",
        darkItemSelectedBg: "rgba(22, 119, 255, 0.12)",
        darkItemHoverBg: "rgba(255,255,255,0.05)",
        darkItemColor: "#94a3b8",
        darkItemSelectedColor: "#60a5fa",
        itemHeight: 44,
        iconSize: 16,
        iconMarginInlineEnd: 10,
      },
      Table: {
        headerBg: "#f8fafc",
        headerColor: "#334155",
        headerSplitColor: "#e2e8f0",
        rowHoverBg: "#f0f7ff",
        borderColor: "#e2e8f0",
        fontSize: 13,
        cellPaddingBlock: 14,
        cellPaddingInline: 16,
        headerBorderRadius: 0,
      },
      Card: {
        paddingLG: 20,
        borderRadiusLG: 12,
      },
      Tabs: {
        itemColor: "#64748b",
        itemActiveColor: "#1677ff",
        itemHoverColor: "#3b82f6",
        inkBarColor: "#1677ff",
        titleFontSize: 14,
      },
      Input: {
        borderRadius: 8,
        controlHeight: 38,
      },
      Select: {
        borderRadius: 8,
        controlHeight: 38,
      },
      Upload: {
        pictureCardSize: 210,
      },
      Statistic: {
        titleFontSize: 12,
        contentFontSize: 26,
      },
      Modal: {
        borderRadiusLG: 14,
      },
      Tag: {
        borderRadiusSM: 6,
      },
    },
  },
};
